import { NavLink } from "react-router-dom";

const NavCovid_19 = () => {
  return (
    <>
      <NavLink to="/covid_19">
        <p>COVID-19</p>
      </NavLink>
    </>
  );
};

export default NavCovid_19;
